const VIDEO_BASE_URL = 'https://players.brightcove.net/1510329454001/a4d923de-cccc-4a40-9756-31e8368d530d_default/index.html?videoId=';

export const ACCIDENT_INFORMATION_LINK = VIDEO_BASE_URL + '5966996968001';
export const CRITICAL_ILLNESS_INFORMATION_LINK = VIDEO_BASE_URL + '5967002469001';
export const DENTAL_INFORMATION_LINK = VIDEO_BASE_URL + '5966981868001';
export const LONG_TERM_DISABILITY_INFORMATION_LINK = VIDEO_BASE_URL + '5967006999001';
export const SHORT_TERM_DISABILITY_INFORMATION_LINK = VIDEO_BASE_URL + '5967005567001';
export const TERM_LIFE_INFORMATION_LINK = VIDEO_BASE_URL + '5967003952001';
export const VISION_INFORMATION_LINK = VIDEO_BASE_URL + '5967003605001';
